import { fields, createSchema, validate as _validate } from '..';

import { roles } from './../../constants';

const { CLIENT, THERAPIST, ADMIN } = roles;

const {
  email,
  password,
  firstName,
  lastName,
  agreedOnTerms,
  agreedAge,
  inviteToken,
  organisationName,
} = fields;

const client = createSchema({
  email,
  password,
  agreedOnTerms,
  agreedAge,
  inviteToken,
});

const therapist = createSchema({
  email,
  firstName,
  lastName,
  password,
  agreedOnTerms,
});

const admin = createSchema({
  email,
  firstName,
  lastName,
  password,
  agreedOnTerms,
  organisationName,
});

const validate = (data) => {
  if (data.role === CLIENT) return _validate(client, data);
  if (data.role === THERAPIST) return _validate(therapist, data);
  if (data.role === ADMIN) return _validate(admin, data);
};

export default validate;
